<template>
  <div class="sport-mvb">
    <ResultSportMvB />
  </div>
</template>

<script>
import ResultSportMvB from "@/components/result/ResultSportMvB.vue";

export default {
  name: "SportMvB",
  components: {
    ResultSportMvB
  }
};
</script>
